import { render, staticRenderFns } from "./DeliveryOrderPickupConfirmationBadge.vue?vue&type=template&id=8c124f70&"
import script from "./DeliveryOrderPickupConfirmationBadge.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrderPickupConfirmationBadge.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOrderPickupConfirmationBadge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports